import { Theme, themeBreakpoints } from '@/app'
import { useMediaQuery } from '@codeleap/web'

export const useIsMobile = () => {
  const mediaQuery = Theme.media.down('small')

  const isMobile = useMediaQuery(mediaQuery, { getInitialValueInEffect: false })

  return isMobile
}

export const useIsTablet = () => {
  const mediaQuery = Theme.media.down('mid')

  const isTablet = useMediaQuery(mediaQuery, { getInitialValueInEffect: false })
  
  return isTablet
}

type Breakpoints = keyof typeof themeBreakpoints

export const useMediaQueryDown = (breakpoint: Breakpoints) => {
  const mediaQuery = Theme.media.down(breakpoint)

  const isMobile = useMediaQuery(mediaQuery, { getInitialValueInEffect: false })

  return isMobile
}
